<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-xl-3.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            i.fa.fa-gamepad
          AdsProviderLookup(
            size="sm"
            type="array"
            :operatorID="operatorID"
            v-model="providerCode"
            :disabled="loading"
            @input="geAdsProviderList(true)"
          )
      .form-group.col-xl-3.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t('ui.status') }}
          b-form-select(v-model="adsStatus" @change="geAdsProviderList(true)" :disabled="loading" size="sm")
            option(:value="null") {{ $t('ui.all') }}
            option(:value="true") {{ $t('ui.active') }}
            option(:value="false") {{ $t('ui.inactive') }}
      .form-group.col-xl-6.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="geAdsProviderList(true)"
          variant="primary"
          size="sm"
        )
      .form-group.col-12.mb-1(v-if="isEditAccess")
        b-button(v-b-modal.addAds type="button" variant="info" size="sm")
          i.fa.fa-plus
          span.ml-1 {{ $t("ui.combine.add_ads") }}
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)"
        )
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12(style="max-height: 70vh; overflow: hidden;")
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="5%")
                  span #
                th(width="10%")
                  span(:title="$t('ui.provider_code')") {{ $t('ui.provider_code') }}
                th(width="10%")
                  span(:title="$t('ui.domain')") {{ $t('ui.domain') }}
                th(width="6%")
                  span(:title="$t('ui.px_pixel_id')") {{ $t("ui.px_pixel_id") }}
                th(width="6%")
                  span(:title="$t('ui.af_apps_id')") {{ $t("ui.af_apps_id") }}
                th(width="6%")
                  span(:title="$t('ui.pp_tid')") {{ $t("ui.pp_tid") }}
                th(width="6%")
                  span(:title="$t('ui.pp_aid')") {{ $t("ui.pp_aid") }}
                th(width="6%")
                  span(:title="$t('ui.gtm_id')") {{ $t("ui.gtm_id") }}
                th(width="6%")
                  span(:title="$t('ui.tt_pixel_id')") {{ $t("ui.tt_pixel_id") }}
                th.text-right(width="10%")
                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                th.text-center(width="10%")
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                th.text-center(width="6%" v-if="isEditAccess")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}

            tbody.clusterize-content
              tr(v-if="adsProviderList.length == 0")
                td(:colspan="isEditAccess ? '15' : '14'").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in adsProviderList")
                td.text-center
                  span.text-center(:title="index + 1") {{ index + 1 }}
                td
                  span(:title="item.provider_code") {{ item.provider_code }}
                td
                  span(:title="item.domain_name") {{ item.domain_name }}
                td
                  span(:title="item.px_pixel_id") {{ item.px_pixel_id }}
                td
                  span(:title="item.af_apps_id") {{ item.af_apps_id }}
                td
                  span(:title="item.pp_tid") {{ item.pp_tid }}
                td
                  span(:title="item.pp_aid") {{ item.pp_aid }}
                td
                  span(:title="item.gtm_id") {{ item.gtm_id }}
                td
                  span(:title="item.tt_pixel_id") {{ item.tt_pixel_id }}
                td.text-right
                  span(:title="item.created_by") {{ item.created_by }}
                  br
                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
                td
                  div.d-flex.justify-content-center.align-items-center
                    label.custom-switch
                      input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="!isEditAccess ? null : changedStatus(item, $event)" :disabled="!isEditAccess")
                      span.custom-switch-indicator
                td.text-center(v-if="isEditAccess")
                  span
                    a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.update')")

    addads(ref="addads" @clicked="afterAdd" @failed="handleFailed")
    editads(ref="editads" :item="editSelectedAds" @clicked="afterEditAds" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addads from "@/components/ads/addAds.vue";
import editads from "@/components/ads/editAds.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import AdsProviderLookup from "@/library/AdsProviderLookup.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    AdsProviderLookup,
    addads,
    editads
  },
  data: () => ({
    loading: false,
    currentPage: 1,
    totalRow: 0,
    adsProviderList: [],
    providerCode: "",
    adsStatus: true,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedAds: null,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeAds;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_ads");
    },
    
  },
  mounted: function() {  },
  methods: {
    refresh() {
      this.geAdsProviderList(true)
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setAdsPageSize", pageSize);
      this.currentPage = 1;
      this.geAdsProviderList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.geAdsProviderList();
    },
    afterEditAds: function() {
      this.geAdsProviderList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_ads"), this.$t("message.success"), "success");
    },
    afterAdd: function() {
      this.geAdsProviderList(true);
      this.$helpers.showDialog(this.$t("ui.combine.add_ads"), this.$t("message.success"), "success");
    },
    onEdit(e) {
      this.editSelectedAds = e;
      this.$refs.editads.$refs.editAds.show();
    },
    geAdsProviderList: function(isSearch) {
      let url = config.adsProviderListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        ads_status: this.adsStatus,
        provider_code: this.providerCode,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.adsProviderList = response.data.dt;
                this.totalRow = this.adsProviderList.length > 0 ? this.adsProviderList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_ads_status_confirm", { name: item.provider_code }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmStatus: function(item, status) {
      let url = config.adsProviderStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        ads_id: item.ads_id,
        new_status: status
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
              this.geAdsProviderList();
            }
          } catch (error) {
            // console.log(error)
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>